import { useEffect, useRef, useState } from 'react';
import EnsembleCard from './EnsembleCard';

export default function EnsembleSection() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const ensembles = [
    {
      id: 'ni',
      name: 'Ni [WaLai 和籟]',
      description: '雅楽と太鼓を融合した悠久のオーケストレーション（6-15名）',
      members: 15,
      image: 'https://public.readdy.ai/ai/img_res/2d5730540ba37577bda26abec403cd83.jpg',
      details: '雅楽の悠久の響きと太鼓の力強さを融合した、最大編成のオーケストレーション。時空を超えた壮大な音楽体験。',
      videoUrl: 'https://youtu.be/5Hlt9AqBq1g?si=UdW836WIVgardIA0',
    },
    {
      id: 'ha',
      name: 'Ha [EarthVoice + LaiOn]',
      description: '島国の原点的な響きを最大化（4-7名）',
      members: 7,
      image: 'https://readdy.ai/api/search-image?query=harmonious-blend-of-earth-and-sky-elements-representing-japanese-island-origins-layered-natural-textures-of-ocean-mountains-and-clouds-deep-blue-and-earth-tone-palette-serene-yet-powerful-atmosphere-minimalist-artistic-composition-emphasizing-unity-and-balance&width=600&height=800&seq=ensemble-ha-003&orientation=portrait',
      details: 'EarthVoiceとLaiOnの融合により、島国の原点的な響きを最大限に引き出す。声、太鼓、笛が一体となった総合的表現。',
      videoUrl: 'https://youtu.be/f65mIotLbYM?si=wLJsby-9sxiE-IkQ',
    },
    {
      id: 'ro',
      name: 'Ro [LaiOn 籟音]',
      description: '太鼓と笛による祭の熱量と藝術性の融合（3-6名）',
      members: 6,
      image: 'https://public.readdy.ai/ai/img_res/edited_c021d6f9841df2c7d181d9033241d064_310c2559.jpg',
      details: '祭の熱量と洗練された藝術性を両立。太鼓の力強さと笛の繊細さが織りなす、躍動感あふれる編成。',
      videoUrl: 'https://youtu.be/AIW3BQ1NQ8s?si=BWqEVyfUvKGBG5kN',
    },
    {
      id: 'i',
      name: 'I [EarthVoice]',
      description: '海洋民族の素朴かつ芳醇な響き（2名）',
      members: 2,
      image: 'https://readdy.ai/api/search-image?query=abstract-minimalist-representation-of-ocean-waves-and-earth-tones-deep-blue-water-meeting-sandy-shores-natural-organic-textures-serene-maritime-atmosphere-simple-clean-background-emphasizing-primal-connection-between-sea-and-land-artistic-photography-with-soft-lighting&width=600&height=800&seq=ensemble-i-001&orientation=portrait',
      details: '海と大地の原初的な響きを、声と身体で表現。素朴でありながら深い芳醇さを持つ、最小編成のアンサンブル。',
      videoUrl: 'https://youtu.be/a_X4_Br1YSw?si=IJSglB3lf9F9i5c4',
    },
  ];

  return (
    <section
      id="ensemble"
      ref={sectionRef}
      className="py-32 px-8 bg-white"
    >
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div
          className={`text-center mb-20 transition-all duration-1000 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <h2 className="font-sans text-5xl font-bold text-sumi mb-4 tracking-wide">
            Ensemble 　"I～Ni"
          </h2>
          <p className="font-serif text-xl text-sumi/70 font-light">
            島国の響きを、四つの編成で。
          </p>
        </div>

        {/* Ensemble Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {ensembles.map((ensemble, index) => (
            <EnsembleCard
              key={ensemble.id}
              ensemble={ensemble}
              index={index}
              isVisible={isVisible}
            />
          ))}
        </div>
      </div>
    </section>
  );
}